import { render } from "./HistoricoObjetoModal.vue?vue&type=template&id=54fe320b&scoped=true"
import script from "./HistoricoObjetoModal.vue?vue&type=script&lang=js"
export * from "./HistoricoObjetoModal.vue?vue&type=script&lang=js"

import "./HistoricoObjetoModal.vue?vue&type=style&index=0&id=54fe320b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fe320b"]])

export default __exports__